'use client';

import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Button } from '@/components/ui/button/button.component';
import { Link } from '@/components/ui/link/link.component';
import { useWhatsappLinkWithAnalytics } from '@/hooks/use-whatsapp/use-whatsapp-link-with-analytics.hook';
import { phonePatientSac } from '@/utils/consts/sac.consts';
import { SearchPartnerData } from '@/app/(main)/(pages)/busca/[slug]/_types/search-partner-data.type';

interface SearchCardClinicTabWhatsappProps {
  schedule: SearchPartnerData;
}

export function SearchCardClinicTabWhatsapp({ schedule }: SearchCardClinicTabWhatsappProps) {
  const { city, state } = schedule.partner.facility;

  const message = `Olá! Gostaria de agendar uma consulta em ${city} - ${state} pela Medprev.`;
  const { url } = useWhatsappLinkWithAnalytics(phonePatientSac.toString(), message);

  return (
    <div data-testid={DataTestIdEnum.SEARCH_CARD_CLINIC_TAB_WHATSAPP}>
      <Button
        startIcon={faWhatsapp}
        startIconSize="1x"
        startIconClassName="text-base"
        asChild
        className="h-10 py-2 text-base"
        data-testid={DataTestIdEnum.SEARCH_CARD_CLINIC_WHATSAPP_BUTTON}
      >
        <Link prefetch={false} href={url} target="_blank" rel="noopener noreferrer">
          Agendar pelo WhatsApp
        </Link>
      </Button>
    </div>
  );
}
